import Swiper, {Autoplay, EffectFade} from "swiper";

Swiper.use([EffectFade])

export default class Makelaars {
    constructor() {
        if (document.getElementById('makelaars') !== null) {
            this.pricing();
            this.challenges();
            this.modal();
        }
    }


    pricing() {
        if (document.querySelector('#pricing')) {
            const swiper = new Swiper('#pricing .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 3000
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.5,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 2.5,
                    },
                    1200: {
                        slidesPerView: 3
                    }
                }
            });
        }
    }

    challenges() {
        if (document.querySelector('#challenges')) {
            const swiper = new Swiper('#challenges .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: false,
                noSwiping: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                // effect: 'fade',
                speed: 500,
            });

            swiper.on('slideChangeTransitionStart', function (e) {
                document.querySelector('#challenges .item.active').classList.remove('active');
            })

            swiper.on('slideChangeTransitionEnd', function (e) {
                const item = document.querySelector('#challenges .item[data-index="' + e.activeIndex + '"]');
                item.classList.add('active');
            })

            document.querySelectorAll('#challenges .item').forEach((item) => {
                item.addEventListener('click', function (e) {
                    const index = item.dataset.index;
                    swiper.slideTo(index);
                })
            })
        }
    }

    modal() {
        const modal = document.querySelector('#pricelistModal')
        const open = document.querySelectorAll('.openModal');
        const close = modal.querySelector('.close');
        const html = document.querySelector('html');

        if (modal && open) {
            open.forEach((item) => {
                item.addEventListener('click', function (e) {
                    e.preventDefault();

                    html.style.overflow = 'hidden';
                    modal.classList.add('active');
                });
            });

            close.addEventListener('click', function (e) {
                e.preventDefault();

                html.style.overflow = 'initial';
                modal.classList.remove('active')
            });
        }
    }
}
